import { withStyles } from '@material-ui/core';

import { CommentsDialog as InnerCommentsDialog } from './CommentsDialog';
import { commentsDialogStyles } from './commentsDialogStyles';

export const CommentsDialog = withStyles(commentsDialogStyles)(InnerCommentsDialog);
